<div [copoScroller]="{ restoreAfterViewInit: false }" #scroller="copoScroller" class="sidenav-content workflow-steps" @routeAnimation>
	<copo-panel-header 	[isBackButtonVisible]="data?.backUrl !== undefined"
						[titleHeaderText]="(data?.titleTranslationKey ?? '') | translate"
						(backButtonClick)="goBackOrOpenDialog()">
		<div class="step-buttons">
			<button class="next-button" type="button" mat-flat-button color="primary" [disabled]="!canNext() || isProcessing"
				(click)="onNext()">				
				<ng-container *ngIf="!isProcessing">
					<span>{{ getNextButtonLabelTranslationKey() | translate }}</span>
					<span *ngIf="nextError" class="error-icon" [title]="nextError | translate"></span>
				</ng-container>
				<copo-loading-spinner *ngIf="isProcessing"></copo-loading-spinner>
			</button>
		</div>
	</copo-panel-header>
	<copo-stepper [steps]="steps" (stepClicked)="onStepClicked($event)" class="copo-stepper-container">
	</copo-stepper>
	<router-outlet 	copoAfterViewInit
					(afterviewinit)="scroller.restoreState()"
					(activate)="onActivate($event)">
	</router-outlet>
</div>
